import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=c1d7c4fc&"
import script from "./adminList.vue?vue&type=script&lang=js&"
export * from "./adminList.vue?vue&type=script&lang=js&"
import style0 from "./adminList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports